import { render, staticRenderFns } from "./searchInsuredReports.vue?vue&type=template&id=b9b32788&"
import script from "./searchInsuredReports.vue?vue&type=script&lang=js&"
export * from "./searchInsuredReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports